import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../user-management/service/userservice';
import { ActivatedRoute, } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import Validation from '../../../../validation/confirm-password-validation';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogService } from '../../../../services/dialog.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent {


   @Input() userDetailInput: any;
  @Input() getRole: any;
  @Input() closePwdForm: any;
  @Output() deleteUserEmit = new EventEmitter();
  @Input() spinnerReceive: boolean = true;
  @Input() selectedTab:string='';
  userListData:any[]=[];
  roleList:any[]=[];
  passwordFormShow:boolean=false;
  userDetailsForm!: FormGroup;
  passwordForm:FormGroup = new FormGroup({});
  spinner:boolean=false;
  myOptions:any;
  submitted:boolean=false;
    type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  currentUserDetail:any;
  constructor(private userService:UserService,private activateRoute:ActivatedRoute,private fb:FormBuilder,private messageService: MessageService,private dialogService:DialogService){}

   ngOnInit(){
      

   this.userDetailsForm = this.fb.group({
      username: ['', Validators.required],
      role: [''],
      email: [''],
      phone_number: [''],
    });

    this.passwordForm = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}'
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      }
    );

     this.activateRoute.params.subscribe((res:any)=>{
      this.userDetailsForm.controls['username'].setValue(this.userDetailInput['username']);
     this.userDetailsForm.controls['role'].setValue(this.userDetailInput['role']);
     this.userDetailsForm.controls['email'].setValue(this.userDetailInput['email']);
     this.userDetailsForm.controls['phone_number'].setValue(this.userDetailInput['phone_number']);
     });

    this.getUserRoles();
   
      this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
       
    };

      this.userService.getCurrentUser().subscribe({
          next:(response:any)=>{
            this.currentUserDetail = response;
          },
          error:(errors:HttpErrorResponse)=>{}
        });
   }

   ngAfterContentChecked(){
    if(this.userDetailInput){
     this.userDetailsForm.controls['username'].setValue(this.userDetailInput['username']);
     this.userDetailsForm.controls['role'].setValue(this.userDetailInput['role']);
     this.userDetailsForm.controls['email'].setValue(this.userDetailInput['email']);
     this.userDetailsForm.controls['phone_number'].setValue(this.userDetailInput['phone_number']);

    if ( this.userDetailInput?.role === 'Admin') {
      this.userDetailsForm?.get('role')?.disable();
    } else {
      this.userDetailsForm?.get('role')?.enable();
    }
    }
   
   }



     getUserRoles(){
    this.userService.getuserRoleList().subscribe((res:any)=>{
      this.roleList = res;
      
    });
  }

   ngAfterViewInit(){
     
   }



   updateUserDetails(){

      if(this.userDetailsForm.valid){
      
    this.spinner = true;
    const formObject = {
      email: this.userDetailsForm.value?.email,
     // is_meeting_user: this.userDetailInput?.is_meeting_user.toString(),
      phone_number: this.userDetailsForm.value?.phone_number,
      role: this.userDetailsForm.controls['role'].value
        ? this.userDetailsForm.controls['role'].value
        : this.userDetailInput?.role,
        username:this.userDetailsForm.value?.username,
     // topic_id: this.userDetailInput?.topic_id,
       id: this.userDetailInput?.id
      //username: this.userDetailsForm.controls['username'].value ? this.userDetailsForm.controls['username'].value : this.userDetailInput?.name,
    };
    this.userService.updateUser(formObject).subscribe(
      (res:any) => {
   this.spinner = false;
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User details updated successfully', life: 3000 });
      },(errors:HttpErrorResponse)=>{
        this.spinner=false;
         this.messageService.add({ severity: 'info', summary: 'Info', detail: errors.error['message'], life: 3000 });
      });

    }
   }


 

   goBack(){}


   selectRole(event:any){
    console.log(event.target.value);
    this.userDetailInput['role']=event.target.value;
    //this.userDetailsForm.controls['role'].setValue(event.target.value);
   }


 deactivateUserFun(data: any) {
   let formObject = data;
   formObject['is_active'] = data.is_active ? false : true;
   delete formObject['created_at'];
   delete formObject['created_by'];
   delete formObject['role_id'];
   this.userService.updateUser(formObject).subscribe(
    (response:any) => {
        if (formObject.is_active) {
 
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User is activated successfully', life: 3000 });
        } else {
      
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User is deactivated successfully', life: 3000 });
        }
      },
    (errors:HttpErrorResponse) => {
       this.spinner=false;
         this.messageService.add({ severity: 'info', summary: 'Info', detail: errors.error['message'], life: 3000 });
     });

    }

   deleteUserFun(userDetailInput:any){
    this.dialogService.openConfirmDialog('',{
        title: 'Delete',
        message: 'Do you want to delete the user?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            this.userService.deleteUser(userDetailInput['id']).subscribe({
             next:(response:any)=>{},
            error:(erors:HttpErrorResponse)=>{}
            });
          }
  }});
   }


    openPasswordForm() {
    this.passwordFormShow = true;
  }


    get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  hidePasswordForm() {
    this.passwordForm.reset();
    this.submitted = false;
    this.passwordFormShow = false;
  }
  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }
    const values = this.passwordForm.value;
    const password = values.password;
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      email: this.userDetailInput?.email,
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };
    this.spinner = true;
    this.userService.resetPassword(formEncript).subscribe({
      next: (response) => {
        this.spinner = false;
        //this.notifier.notify('default', 'Password Changed SuccessFully !');
        this.passwordForm.reset();
        this.submitted = false;
        this.passwordFormShow = false;
      },
      error: (err) => {
        console.log(err);
       
        this.spinner = false;
      },
    });
  }
  

}
